import { useSelector } from 'react-redux';
import { getIsStartTileRefreshEnabled, getStartNodeId } from 'modules/workflows/ducks';
import { WarningFill } from 'ui/icons';
import { PANEL_WIDTH } from 'ui/workflows/nodeTilePanel/NodeTilePanel.styled';
import { NodesCountWarningBanner, NodesCountWarningContainer } from './WorkflowFlowchart.styles';

type NodesCountWarningProps = {
  openedNodeId: number;
};

export const NODES_COUNT_WARNING_BANNER = 'nodes-count-warning-banner';

export const NodesCountWarning = ({ openedNodeId }: NodesCountWarningProps) => {
  const isNodeEditorOpen = !!openedNodeId;
  const isStartTileRefreshEnabled = useSelector(getIsStartTileRefreshEnabled);
  const isOpenedNodeStartNode = useSelector(getStartNodeId) === openedNodeId;
  const nodeEditorWidth = isStartTileRefreshEnabled && isOpenedNodeStartNode ? 670 : 525;
  const subWidth = isNodeEditorOpen ? nodeEditorWidth : PANEL_WIDTH;
  return (
    <NodesCountWarningBanner data-test={NODES_COUNT_WARNING_BANNER} subWidth={subWidth}>
      <NodesCountWarningContainer>
        <WarningFill />
        Woah! This journey is getting pretty big! Journeys perform best when they have 100 tiles or
        less. Please consider using a “Send to journey” tile to extend this journey.
      </NodesCountWarningContainer>
    </NodesCountWarningBanner>
  );
};
